<template>
    <div>


        <div @click="show_vb.val = true">
            <slot></slot>
        </div>

        <tq-popup :show="show_vb" max-width="330px" :show-close-btn="true" :pe_on-close-do_f="() => {this.customChoose_b=false}">

            <div v-if="!customChoose_b" >

                <div>
                    <div v-for="color in gv_colorsDark" :style="{'background': color}"
                         @click="m_pickColor_f(color)"
                         class="TQ_inline TQ_width_60px TQ_height_60px TQ_margin_4px TQ_borderRadius TQ_box_shadow TQ_clickable">
                    </div>
                </div>

                <hr>
                <div class="TQ_box_shadow TQ_bg_gray1 TQ_textColor_white TQ_text_24px TQ_padding_8px TQ_borderRadius TQ_clickable" @click="customChoose_b = true">
                    {{ass_strings.twoWords_moreColors[p_systemLangCode_e]}}
                </div>

            </div>
            <div v-else class="TQ_padding_8px ">


                <!-- choose color -->
                <div class="TQ_align_initial TQ_margin_4px">

                    <div :style="{background: co_chosenColor_f}"
                         class="TQ_padding_8px TQ_inline TQ_height_36px TQ_width_36px TQ_verticalAlignMiddle TQ_borderRadius TQ_box_shadow ">
                    </div>
                    <div class="TQ_padding_4px TQ_inline"> </div>
                    <div class="TQ_inline TQ_verticalAlignMiddle TQ_text_20px">
                        {{ass_strings.twoWords_chosenColor[p_systemLangCode_e]}}
                    </div>

                </div>
                <div class="TQ_padding_4px"></div>

                <!-- colors range -->
                <div class="TQ_margin_4px">
                    <!-- red -->
                    <div class="TQ_textAlign_initial">
                        {{ass_strings.oneWord_red[p_systemLangCode_e]}}
                    </div>

                    <input type="range" min="0" max="255"
                           @mousedown="m_mousedown_f(enum_colors_s.red)"
                           @mouseup="m_mouseup_f()"
                           @mousemove="m_mouseover_f($event)"
                           @mouseleave="m_mouseup_f()"
                           v-model.number="custom_red"
                           :style="{background: '#' + formatToHex(custom_red) + '0000'}" >

                    <div class="TQ_align_end TQ_text_12px">
                        {{custom_red}}
                    </div>

                    <!-- green -->
                    <div class="TQ_textAlign_initial">
                        {{ass_strings.oneWord_green[p_systemLangCode_e]}}
                    </div>
                    <input type="range" min="0" max="255"
                           @mousedown="m_mousedown_f(enum_colors_s.green)"
                           @mouseup="m_mouseup_f()"
                           @mousemove="m_mouseover_f($event)"
                           @mouseleave="m_mouseup_f()"
                           v-model.number="custom_green"
                           :style="{background: '#00' + formatToHex(custom_green) + '00'}">
                    <div class="TQ_align_end TQ_text_12px">
                        {{custom_green}}
                    </div>

                    <!-- blue -->
                    <div class="TQ_textAlign_initial">
                        {{ass_strings.oneWord_blue[p_systemLangCode_e]}}
                    </div>
                    <input type="range" min="0" max="255"
                           v-model.number="custom_blue"
                           @mousedown="m_mousedown_f(enum_colors_s.blue)"
                           @mouseup="m_mouseup_f()"
                           @mousemove="m_mouseover_f($event)"
                           @mouseleave="m_mouseup_f()"
                           :style="{background: '#0000' + formatToHex(custom_blue)}"><br>
                    <div class="TQ_align_end TQ_text_12px">
                        {{custom_blue}}
                    </div>

                </div>
                <div class="TQ_padding_4px"></div>
                <hr>

                <!-- approve button-->
                <div @click="m_pickColor_f()">
                    <div class="TQ_padding_8px TQ_bg_green TQ_inline TQ_box_shadow TQ_borderRadius TQ_text_20px">
                        {{ass_strings.oneWord_approve[p_systemLangCode_e]}}
                    </div>
                </div>

            </div>



        </tq-popup>
    </div>

</template>

<script>
    import TqPopup from "../basic/TqPopup";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {enum_colors_s, enum_langCodes} from "../../../functions/src/shareCode/Share_S_Enum";
    import {gv_colorsDark} from "../../../functions/src/shareCode/Share_Ass_GlobalVariable";

    export default {
        name: "TqPickColor",
        components: {TqPopup},
        props:{
            p_systemLangCode_e:{
                require:true,
                type:String,
                validator(val){
                    return validator_enum_fb(enum_langCodes, val)
                }
            },
            p_initColor_s:{
                type:String,
                default(){
                    return gv_colorsDark[0]
                }
            },
            pe_changeColor_s:{
                require:true,
                type:Function,
            },
            p_preventDefault_b:{
                type: Boolean,
                default : false
            }

        },
        data(){
            return {
                show_vb : {val : false},
                customChoose_b : false,

                mouseDownColor_e : null,
                custom_red : 125,
                custom_green : 125,
                custom_blue : 125,
                maxWidth_n : 255,

                gv_colorsDark : gv_colorsDark,
                enum_colors_s : enum_colors_s,
                ass_strings : ass_strings,


            }
        },
        computed : {
              co_chosenColor_f(){
                  return '#' + this.formatToHex(this.custom_red) + this.formatToHex(this.custom_green) + this.formatToHex(this.custom_blue)
              }
        },
        methods:{
            m_mousedown_f(color_e){
                this.mouseDownColor_e = color_e

            },
            m_mouseup_f(){
                this.mouseDownColor_e = null
            },
            m_mouseover_f(event){

                if(!this.p_preventDefault_b || this.mouseDownColor_e == null){
                    return
                }

                let newColor_n = Math.ceil(this.maxWidth_n*event.offsetX/event.srcElement.clientWidth)
                if(newColor_n<0){newColor_n = 0}
                if(newColor_n>255){newColor_n=255}

                switch(this.mouseDownColor_e){
                    case enum_colors_s.green:
                        this.custom_green = newColor_n

                        break;
                    case enum_colors_s.red:
                        this.custom_red = newColor_n
                        break;
                    case enum_colors_s.blue:
                        this.custom_blue = newColor_n
                        break;
                }
            },

            formatToHex(num_n){

                if(num_n < 16){
                    return "0" + num_n.toString(16)
                }
                return num_n.toString(16)
            },
            m_pickColor_f(color_s){

                this.m_setRedGreenBlue_f(color_s)

                this.pe_changeColor_s(this.co_chosenColor_f)
                this.show_vb.val = false
                this.customChoose_b = false
            },
            m_setRedGreenBlue_f(color_s){

                if(color_s != null){
                    this.custom_red = parseInt(color_s.substring(1,3), 16);
                    this.custom_green = parseInt(color_s.substring(3,5), 16);
                    this.custom_blue = parseInt(color_s.substring(5,7), 16);
                }
            },
        },
        created(){
            this.m_setRedGreenBlue_f(this.p_initColor_s)

        }


    }
</script>

<style scoped lang="scss">

    .slidecontainer {
        width: 100%; /* Width of the outside container */
    }

    /* The slider itself */
    input {
        -webkit-appearance: none;  /* Override default CSS styles */
        appearance: none;
        width: 100%; /* Full-width */
        height: 34px; /* Specified height */
        background: #d3d3d3; /* Grey background */
        outline: none; /* Remove outline */
        opacity: 0.7; /* Set transparency (for mouse-over effects on hover) */
        -webkit-transition: .2s; /* 0.2 seconds transition on hover */
        transition: opacity .2s;
        border-radius: 5px;

    }

    /* Mouse-over effects */
    input:hover {
        opacity: 1; /* Fully shown on mouse-over */
    }


    /* Special styling for WebKit/Blink */
    input[type=range]::-webkit-slider-thumb {
        -webkit-appearance: none;
        border: 1px solid #000000;
        height: 40px;
        width: 12px;
        border-radius: 3px;
        background: #ffffff;
        cursor: pointer;
        box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d; /* Add cool effects to your sliders! */
    }

    /* All the same stuff for Firefox */
    input[type=range]::-moz-range-thumb {
        box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
        border: 1px solid #000000;
        height: 36px;
        width: 16px;
        border-radius: 3px;
        background: #ffffff;
        cursor: pointer;
    }

    /* All the same stuff for IE */
    input[type=range]::-ms-thumb {
        box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
        border: 1px solid #000000;
        height: 36px;
        width: 16px;
        border-radius: 3px;
        background: #ffffff;
        cursor: pointer;
    }

    /* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
    /*input::-webkit-slider-thumb {*/
        /*height: 100px;*/
        /*width: 100px;*/
        /*!*-webkit-appearance: none; !* Override default look *!*!*/
        /*!*appearance: none;*!*/
        /*!*width: 25px; !* Set a specific slider handle width *!*!*/
        /*!*height: 25px; !* Slider handle height *!*!*/
        /*!*background: #4CAF50; !* Green background *!*!*/
        /*!*cursor: pointer; !* Cursor on hover *!*!*/
    /*}*/

    /*input::-moz-range-thumb {*/
        /*width:100px; !* Set a specific slider handle width *!*/
        /*height: 100px; !* Slider handle height *!*/
        /*background: #4CAF50; !* Green background *!*/
        /*cursor: pointer; !* Cursor on hover *!*/
    /*}*/
</style>